import { Globe } from "lucide-react";
import React, { useState } from "react";

export default function MyTabs2({ tabs, className = "", onTabChange }) {
  const [active, setActive] = useState(0);

  return (
    <div className={` flex flex-col  `}>
      {/* Tab Headers */}
      <div className={` mb-4 flex   ${className} `}>
        <div className="flex space-x-4 w-fit items-start justify-between bg-slate-300/30 dark:bg-slate-400/20 rounded-md border-gray-300 p-[4px] ">
          {tabs.map((tab, i) => (
            <button
              key={i}
              onClick={() => {
                setActive(i);
                if (onTabChange) {
                  onTabChange(tab);
                }
              }}
              className={`px-2 py-[4px] text-xs font-medium  rounded-sm flex   space-x-1
              ${
                active === i
                  ? "  text-blue-500  bg-white shadow-sm"
                  : "text-gray-600 dark:text-white hover:text-blue-600"
              }`}
            >
              
              {tab.icon && <tab.icon className="w-[15px] h-[15px]" />}
              <span className="block text-center">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
